import React from "react";
import { changeParameter, filterSingleValue } from "../../../api_calls/TableauVisuals";
import { useDispatch, useSelector } from "react-redux";
import MultiSelect from "../Selectors/MultiSelect";
import { clip_names_in_range } from "../../../api_calls/campaignRequests";

import { Box, FormControl, FormControlLabel, FormLabel, Tooltip } from "@mui/material";
import { StyledSwitch } from "../StyledComponents/styled";
import { updateStateData } from "../../../Store/actions";

const ClipNameFilter = ({ reduxKeywordToSaveValue, usedFor }) => {
  const clipDetails = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [changesMade, setChangesMade] = React.useState(false);
  const [clipSelection, setClipSelection] = React.useState([]);
  const [clipNameOptionSelected, setClipNameOptionsSelected] = React.useState([]);

  const [checked, setChecked] = React.useState(false);

  // for clips boolean switch
  const handleChange = (event) => {
    setChecked(event.target.checked);
    // if (event.target.checked === true) {
    //   changeParameter("Clips", "Show", vizId);
    //   if (clipSelection.length !== 0) {
    //     filterSingleValue(fieldName, clipSelection, vizId);
    //   }
    // } else {
    //   const allClipNames = clip_names_in_range(usedFor);
    //   changeParameter("Clips", "Hide", vizId);
    //   filterSingleValue(
    //     fieldName,
    //     allClipNames.map((clipInfo) => {
    //       return clipInfo.id;
    //     }),
    //     vizId
    //   );
    // }
    dispatchAction(updateStateData({
      campaign_overview_show_clips: event.target.checked
    }));
  };

  const clipNameFilterJsx = () => {
    return (
      <MultiSelect
        enableFullWidth={false}
        label={"Visual Name"}
        readOnlyFlag={typeof usedFor !== "undefined" && usedFor === "clip-overview" ? (checked ? false : true) : false}
        options={clip_names_in_range(usedFor)}
        defaultVal={clipNameOptionSelected}
        selectionCheck={(option, value) => option.label === value.label}
        usedFor="clipNameFilter"
        onChangeCall={(selectedOption) => {
          let userChoices = [];
          setChangesMade(true);
          selectedOption.forEach((chosen) => {
            if (chosen.label !== "(All)") {
              userChoices.push(chosen.id);
            } else {
              userChoices.push([...new Set(clipDetails.clip_names_list)]);
            }
          });
          setClipSelection(userChoices);
          setClipNameOptionsSelected(selectedOption);
        }}
        onBlurCall={(e) => {
          if (clipSelection.length !== 0 && changesMade === true) {
            dispatchAction(updateStateData({
              [reduxKeywordToSaveValue]: clipSelection
            }))
            setChangesMade(false);
          }
        }}
      />
    );
  };

  React.useEffect(() => {
    const allClipNames = clip_names_in_range(usedFor);
    setClipNameOptionsSelected(allClipNames);

    dispatchAction(updateStateData({
      campaign_overview_show_clips: false,
      [reduxKeywordToSaveValue]: allClipNames.map(clip => {
        return clip.id
      }),
    }));
  }, []);

  return (
    <>
      {typeof usedFor !== "undefined" && usedFor === "clip-overview" ? (
        <>
          <Box sx={{ alignContent: "center" }}>
            <FormControl
              component="fieldset"
              variant="standard"
              sx={{ display: "flex", alignItems: "center", flexDirection: "row" }}
            >
              <FormLabel component="legend">Visuals</FormLabel>
              <Tooltip title="Show/Hide Visual Name">
                <FormControlLabel
                  control={<StyledSwitch checked={checked} name="Metric Swap" onChange={handleChange} />}
                  labelPlacement="right"
                  label={checked ? "On" : "Off"}
                  sx={{ fontSize: "12px", minWidth: 100 }}
                />
              </Tooltip>
            </FormControl>
          </Box>
          <Box sx={{ width: 250, alignContent: "center" }}>{clipNameFilterJsx()}</Box>
        </>
      ) : (
        <>{clipNameFilterJsx()}</>
      )}
    </>
  );
};

export default ClipNameFilter;
